<template>
    <v-text-field
        outlined
        dense
        :maxlength="$props.maxlength"
        :hide-details="hideDetails"
        :error="errorBorder"
        :error-messages="error"
        :hint="$props.hint"
        :label="$props.label"
        :mask="$props.mask"
        :placeholder="$props.placeholder"
        :readonly="$props.readonly"
        :type="$props.type"
        v-model="inputValue"
        @blur="handleBlur"
    ></v-text-field>
</template>

<script>
export default {
    name: 'InputField',
    props: {
        readonly: Boolean,
        value: {String, Number},
        errorBorder: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        placeholder: String,
        label: String,
        type: String,
        mask: String,
        hint: {
            type: String,
            default: ''
        },
        maxlength: Number
    },
    data() {
        return {
            inputValue: this.$props.value
        };
    },
    computed: {
        hideDetails() {
            return this.$props.error === '' && this.$props.hint === '';
        }
    },
    watch: {
        inputValue() {
            this.$emit('input', this.inputValue);
        },
        value() {
            this.inputValue = this.$props.value;
        }
    },
    methods: {
        handleBlur() {
            this.$emit('blur', this.inputValue);
        }
    }
};
</script>

<style scoped></style>
